module.exports = __webpack_public_path__ + "static/media/tomorrow-edition-2025.17eabf90.jpg";